/**
 * 소리 설정. **처음에는 꺼져 있다** — 브라우저는 손짓 없이 소리를 내지 못하게 막고, 모르는 사이에 소리가 나는 게임은
 * 폰에서 반갑지 않다. 켠 사람의 선택은 저장해 다음에도 켜진 채로 연다(소리는 첫 손짓부터 난다).
 *
 * 단계는 셋: 끔 → 작게 → 크게. 밝기 단추처럼 누를 때마다 넘어간다. 음량 막대를 두지 않은 것은 편성 화면의 줄에 자리가
 * 없어서다 — 효과음과 음악을 따로 조절하는 설정 창은 음악을 넣을 때 만든다.
 */
export type SoundLevel = 0 | 1 | 2;

const KEY = 'ildangbaek.sound';

/** 단계의 음량(선형 이득). 시작값이다 — 들어 보고 다시 정한다. */
export const LEVEL_GAIN: readonly number[] = [0, 0.3, 0.7];
export const LEVEL_LABEL: readonly string[] = ['소리 끔', '소리 작게', '소리 크게'];

/** 저장된 단계. 없거나 읽을 수 없거나 이상한 값이면 끔. */
export function savedLevel(): SoundLevel {
  try {
    const v = localStorage.getItem(KEY);
    return v === '1' ? 1 : v === '2' ? 2 : 0;
  } catch {
    return 0;
  }
}

/** 소리를 한 번이라도 골랐는가. 아직이면 편성 화면의 소리 단추를 눈에 띄게 그린다 — 꺼진 채 시작하므로 있는 줄 모른다. */
export function soundChosen(): boolean {
  try {
    return localStorage.getItem(KEY) !== null;
  } catch {
    return true;
  }
}

export function saveLevel(level: SoundLevel): void {
  try {
    localStorage.setItem(KEY, String(level));
  } catch {
    // 저장이 막혀도 이번 창에서는 바뀐다.
  }
}

/** 끔 → 작게 → 크게 → 끔. */
export function nextLevel(level: SoundLevel): SoundLevel {
  return level === 0 ? 1 : level === 1 ? 2 : 0;
}
